/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { MagnetWithLinks } from '../models/magnet-with-links';
@Injectable({
  providedIn: 'root',
})
class MagnetsWithLinksService extends __BaseService {
  static readonly MagnetsWithLinksGetPath = '/magnets-with-links/{magnetId}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Returns the magnet with links
   * @param params The `MagnetsWithLinksService.MagnetsWithLinksGetParams` containing the following parameters:
   *
   * - `magnetId`: GUID of the magnet
   *
   * - `Authorization`: Bearer JSON Web Token
   *
   * @return OK
   */
  MagnetsWithLinksGetResponse(params: MagnetsWithLinksService.MagnetsWithLinksGetParams): __Observable<__StrictHttpResponse<MagnetWithLinks>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/magnets-with-links/${encodeURIComponent(String(params.magnetId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<MagnetWithLinks>;
      })
    );
  }
  /**
   * Returns the magnet with links
   * @param params The `MagnetsWithLinksService.MagnetsWithLinksGetParams` containing the following parameters:
   *
   * - `magnetId`: GUID of the magnet
   *
   * - `Authorization`: Bearer JSON Web Token
   *
   * @return OK
   */
  MagnetsWithLinksGet(params: MagnetsWithLinksService.MagnetsWithLinksGetParams): __Observable<MagnetWithLinks> {
    return this.MagnetsWithLinksGetResponse(params).pipe(
      __map(_r => _r.body as MagnetWithLinks)
    );
  }
}

namespace MagnetsWithLinksService {

  /**
   * Parameters for MagnetsWithLinksGet
   */
  export interface MagnetsWithLinksGetParams {

    /**
     * GUID of the magnet
     */
    magnetId: string;

    /**
     * Bearer JSON Web Token
     */
    Authorization: string;
  }
}

export { MagnetsWithLinksService }